import React, {
  Component
} from 'react'
import Axios from 'axios';
import MyApp from '../main';
import TagManager from './../utils/tagManager';

class Pagination extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentPage: 0,
      maxPage: null,
      loading: false
    }
  }

  componentDidMount() {
    let select = this.props.proxy.querySelector('.see-more-items .inline-button__cta');
    if (select) {
      select.addEventListener("click", this.moreEvents.bind(this));
      this.setState({currentPage: this.props.page ? this.props.page : 1});
    }
    let noJs = this.props.proxy.querySelector('.no-js');
    if (noJs) {
      noJs.style.display = 'none';
    }

    this.setState({maxPage: this.props.maxPage});
    var form = this.props.proxy.querySelector("form");
    if (form) {
      form.submit = this.submitForm.bind(this);
    }

    window.fixRight = this.fixRight.bind(this);
    this.fixRight();
  }

  fixRight() {
    let wrapper = this.props.proxy.querySelector('.pagination-content-wrapper');
    let rightEl = document.querySelector('.floaty-right');
    if (!wrapper || !rightEl)
      return;
    let rightElHeight = rightEl.offsetHeight
    let top = wrapper.offsetTop - rightEl.offsetTop;
    let height = wrapper.offsetHeight

    if (rightElHeight < (top + height)) {
      let diff = (rightElHeight - top);
      let margin = (474 + 40) - (diff - (474 + 40)) + 1
      rightEl.style.marginBottom = margin + 'px';
    }
  }

  submitForm(element) {
    if (!this.state.loading) {
      this.seeMoreItems(0, true, element.parentNode);
    }
    return false;
  }

  moreEvents(e = null) {
    if (!this.state.loading) {
      this.setState({loading: true}, () => {
          this.seeMoreItems();
      });
    }
  }

  getQueryString() {
    let queryString = '?';
    let form = this.props.proxy.querySelector("form");
    if (form) {
      let params = [];
      let inputs = form.querySelectorAll('input,input[type="hidden"],select');
      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].name) {
          params.push(encodeURIComponent(inputs[i].name) + '=' + encodeURIComponent(inputs[i].value));
        }
      }
      queryString += params.join('&');
    }
    return queryString;
  }

  seeMoreItems(nextPage = null, resetDOM = false, selectElement = null) {
    TagManager.pushEvent('voir-plus', '', '', location.pathname);
    let ctaButton = this.props.proxy.querySelector('.see-more-items .inline-button__cta');
    if (ctaButton) {
      ctaButton.classList.add('loading')
    }
    if (selectElement) {
      selectElement.classList.add('loading')
    }
    let newPage = (nextPage !== null ? nextPage : parseInt(this.state.currentPage)) + 1;
    let endpoint = this.props.endpoint.replace(':page', newPage);

    let queryString = this.getQueryString();
        queryString = endpoint.indexOf('?') !== -1? queryString.replace('?',''):queryString;

    Axios.get(endpoint + queryString, {
      headers: {'X-Requested-With': 'XMLHttpRequest'},
    }).then((response) => {
      if (resetDOM) {
        this.props.proxy.querySelector('.pagination-content-wrapper').innerHTML = "";
      }

      let container = document.createElement('div');
      container.className = "wrapp loaded-more";
      container.innerHTML = response.data.view;
      this.props.proxy.querySelector('.pagination-content-wrapper').appendChild(container);
      MyApp.update(container);

      let select = this.props.proxy.querySelector('.see-more-items');
      select.classList.add('loaded-more');

      if (response.data.pagination['last_page'] != this.state.maxPage) {
        this.setState({maxPage: response.data.pagination.last_page});
      }
      this.setState({loading: false, currentPage: newPage});
      if (ctaButton) {
        ctaButton.classList.remove('loading')
      }
      if (selectElement) {
        selectElement.classList.remove('loading')
      }
      this.fixRight();
    });

  }

  componentDidUpdate(nextProps) {
    if (this.state.currentPage >= this.state.maxPage) {
      this.props.proxy.querySelector('.see-more-items').style.display = 'none';
    } else {
      this.props.proxy.querySelector('.see-more-items').style.display = 'block';
    }
    this.fixRight();
  }

  render() {
    return <div></div>
  }
}

export default (Pagination)


// WEBPACK FOOTER //
// ./resources/assets/frontend/js/components/Pagination.js